var COMBINING_MARKS = new RegExp('[\u0300-\u036f]', 'g');

function stringToSlug(str) {
    return String(str || '')
        .normalize('NFD')
        .replace(COMBINING_MARKS, '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-');
}

function scriptsCard(productCard, color, cod) {
    const colorSelector = productCard.querySelector('.color-selector');
    if (colorSelector?.childElementCount > 0) {
        return
    }
    const sizeSelector = productCard.querySelector('.size-selector');
    const productImage = productCard.querySelector('.product-image');
    const productImageHover = productCard.querySelector('.product-image.hover');
    const productPriceList = productCard.querySelector('.price .list');
    const productPriceBest = productCard.querySelector('.price .best');
    const productInstallments = productCard.querySelector('.installments');
    const variationMessage = productCard.querySelectorAll('.variation-message');
    const addCart = productCard.querySelector('.buy');

    const productLink = productCard.getAttribute('data-product-handle');

    const imagesLink = productCard.querySelector('a.images');

    var quickViewSizes = document.querySelector('.selectorMob .sizes');
    const quickView = productCard.querySelector('#buy_mobile');

    let currentId = null;
    let selectedColor = null;
    let selectedSize = null;
    let selectedHandle = productLink;

    const colorInitial = color;

    const codProd = cod;

    // Helper function to build image URLs with width parameter safely
    function buildImageSrcset(baseUrl) {
        const widths = [352, 600];
        return widths.map(width => {
            try {
                // Create absolute URL if baseUrl is relative
                const url = new URL(baseUrl, window.location.href);
                url.searchParams.set('width', width);
                return `${url.toString()} ${width}w`;
            } catch (e) {
                // Fallback for invalid URLs
                const separator = baseUrl.includes('?') ? '&' : '?';
                return `${baseUrl}${separator}width=${width} ${width}w`;
            }
        }).join(', ');
    }

    const query = `
      query ProductsByMetafield {
        collection(handle: "homepage") {
          handle
          products(
            first: 100,
            filters: {
              productMetafield: {
                namespace: "custom",
                key: "grupo_de_produto_v2",
                value: "${codProd}"
              }
            }
          ) {
            edges {
              node {
                handle
                title
                images(first: 2) {
                  edges {
                    node {
                      originalSrc
                      altText
                    }
                  }
                }
                metafields(identifiers: [{ namespace: "custom", key: "cor" }]) {
                  value
                }
                variants(first: 20) {
                  edges {
                    node {
                      id
                      availableForSale
                        priceV2 {
                            amount
                            currencyCode
                        }
                        compareAtPriceV2 {
                            amount
                            currencyCode
                        }
                      metafields(identifiers: [
                        { namespace: "custom", key: "size" },
                        { namespace: "custom", key: "estoque_cd" }
                      ]) {
                        value
                      }
                      image {
                        originalSrc
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }`;

    async function fetchProducts() {
        const response = await fetch('/api/2024-10/graphql.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': '4b1e9dac248d11e713266d9a23e1987b', // Substitua pelo seu token
            },
            body: JSON.stringify({ query }),
        });

        const result = await response.json();

        const allProducts = result.data.collection.products.edges;
        const availableProducts = allProducts.filter(({ node: product }) => {
            return product.variants.edges
            // .some(({ node: variant }) => {
            //     const estoqueCd = parseInt(variant.metafields?.[1]?.value || '0', 10);
            //     return estoqueCd > 0;
            // });
        }).map(({ node: product }) => {
            const filteredProduct = { ...product };
            filteredProduct.variants = {
                edges: product.variants.edges
                // .filter(({ node: variant }) => {
                //     const estoqueCd = parseInt(variant.metafields?.[1]?.value || '0', 10);
                //     return estoqueCd > 0;
                // })
            };
            return { node: filteredProduct };
        });

        return availableProducts;
    }

    async function updateSelectors() {
        try {
            const products = await fetchProducts();

            if (products.length === 0) {
                console.warn(`Nenhum produto encontrado para o grupo: ${codProd}`);
                selectedColor = color;
                addEventListeners();
                return;
            }

            // Limpar o conteúdo anterior dos seletores
            colorSelector.innerHTML = '';
            sizeSelector.innerHTML = '';

            // Rastrear cores e tamanhos já adicionados para evitar duplicatas
            const addedColors = new Set();
            const addedSizes = new Map(); // Map de color -> Set de tamanhos

            // Find the product with the initial color first
            const initialColorProduct = products.find(({ node: product }) =>
                product.metafields?.[0]?.value?.toLowerCase() === colorInitial?.toLowerCase()
            );

            // Se não encontrar o produto com a cor inicial, usar o primeiro produto
            const colorProducts = initialColorProduct ?
                [initialColorProduct, ...products.filter(p => p !== initialColorProduct)] :
                products;

            // Processar todos os produtos, começando pelo de cor inicial se existir
            for (const { node: product } of colorProducts) {
                const color = product.metafields?.[0]?.value || 'Sem cor';

                // Evitar adicionar cores duplicadas
                if (addedColors.has(color.toLowerCase())) {
                    continue;
                }
                addedColors.add(color.toLowerCase());

                // Inicializar conjunto de tamanhos para esta cor se ainda não existir
                if (!addedSizes.has(color)) {
                    addedSizes.set(color, new Set());
                }

                const hexa = `https://cdn.shopify.com/s/files/1/0865/9134/0841/files/cor-${stringToSlug(color)}.png`;
                const imageUrl = product.images?.edges[0]?.node?.originalSrc || product.featured_image?.src;
                const imageUrlHover = product.images?.edges[1]?.node?.originalSrc || product.featured_image?.src;
                const list_price = product.variants?.edges[0]?.node?.compareAtPriceV2?.amount || 0;
                const best_price = product.variants?.edges[0]?.node?.priceV2?.amount || 0;

                // Adicionar opção de cor
                colorSelector.innerHTML += `
                    <a href="#" class="color-option" title="${color}" data-bestprice="${best_price}" data-listprice="${list_price}" data-color="${color}" data-handle="${product.handle}" data-title="${(product.title || '').replace(/"/g, '&quot;')}" data-image="${imageUrl}" data-imagehover="${imageUrlHover}">
                        <img src="${hexa}" alt="${color}" />
                    </a>`;

                // Se é a primeira cor ou a cor inicial, definir como selecionada
                if (!selectedColor || color.toLowerCase() === colorInitial?.toLowerCase()) {
                    selectedColor = color;
                    selectedHandle = product.handle;
                    productImage.src = imageUrl;
                    if (productImageHover) {
                        productImageHover.src = imageUrlHover;
                    }
                }

                // Adicionar opções de tamanho para esta cor
                if (product.variants && product.variants.edges) {
                    for (const { node: variant } of product.variants.edges) {
                        const size = variant.metafields?.[0]?.value;
                        if (!size) continue;

                        // Evitar adicionar tamanhos duplicados para esta cor
                        if (addedSizes.get(color).has(size)) {
                            continue;
                        }
                        addedSizes.get(color).add(size);

                        const priceList = variant.compareAtPriceV2?.amount || 0;
                        const priceBest = variant.priceV2?.amount || 0;
                        const variantId = variant.id.split('ProductVariant/')[1];
                        const estoqueCd = parseInt(variant.metafields?.[1]?.value || '0', 10);

                        sizeSelector.innerHTML += `
                            <button type="button" class="size-option" data-bestprice="${priceBest}" data-listprice="${priceList}" data-color="${color}" data-size="${size}" data-id="${variantId}" data-stock="${estoqueCd}" ${estoqueCd <= 0 ? 'disabled' : ''}>
                                ${size == "." ? "U" : size}
                            </button>`;
                    }
                }

                // Limitar o número de cores mostradas no mobile
                //  && innerWidth < 1024
                if (addedColors.size >= 4) {
                    break;
                }
            }

            // Adicionar link para mais cores no mobile se necessário
            //  && innerWidth < 1024
            if (products.length > 4) {
                colorSelector.innerHTML += '<a style="font-size: 11px;white-space: nowrap;" href="/products/' + productLink + '">+ Cores</a>';
            }

            // Selecionar a cor inicial e tamanhos relacionados
            const selectedColorOption = colorSelector.querySelector(`[data-color="${selectedColor}"]`);
            if (selectedColorOption) {
                selectedColorOption.classList.add('selected');

                // Keep links synced with selected color/product
                selectedHandle = selectedColorOption.dataset.handle || selectedHandle;
                if (selectedHandle) {
                    productCard.setAttribute('data-product-handle', selectedHandle);
                    if (imagesLink) imagesLink.href = `/products/${selectedHandle}`;
                    const productTitleLink = productCard.querySelector('h3 a');
                    if (productTitleLink) {
                        productTitleLink.href = `/products/${selectedHandle}`;
                        if (selectedColorOption.dataset.title) productTitleLink.textContent = selectedColorOption.dataset.title;
                    }
                }

                // Atualizar preços e imagens iniciais
                const priceBest = selectedColorOption.dataset.bestprice;
                const priceList = selectedColorOption.dataset.listprice;
                updatePriceDisplay(priceBest, priceList);
            }

            filterSizeOptionsByColor(selectedColor);
            addEventListeners();
        } catch (error) {
            console.error('Erro ao atualizar seletores:', error);
            // Fallback para garantir que os event listeners sejam adicionados mesmo em caso de erro
            addEventListeners();
        }
    }

    function addEventListeners() {
        const colorOptions = productCard.querySelectorAll('.color-option');
        const sizeOptions = productCard.querySelectorAll('.size-option');
        const productTitle = productCard.querySelector('h3 a');

        colorOptions.forEach((option) => {
            option.addEventListener('click', (event) => {
                event.preventDefault();

                selectedColor = option.dataset.color;
                selectedHandle = option.dataset.handle || selectedHandle;
                const imageUrl = option.dataset.image;
                const imageUrlHover = option.dataset.imagehover;
                const priceBest = option.dataset.bestprice;
                const priceList = option.dataset.listprice;

                if (selectedHandle) {
                    productCard.setAttribute('data-product-handle', selectedHandle);
                    if (imagesLink) imagesLink.href = `/products/${selectedHandle}`;
                    if (productTitle) productTitle.href = `/products/${selectedHandle}`;
                }

                // Update the product title with the selected color product's real title
                if (productTitle && option.dataset.title) {
                    productTitle.textContent = option.dataset.title;
                }

                // Update images
                if (productImage) {
                    productImage.src = imageUrl;
                    productImage.srcset = buildImageSrcset(imageUrl);
                }
                if (productImageHover) {
                    productImageHover.src = imageUrlHover;
                    productImageHover.srcset = buildImageSrcset(imageUrlHover);
                }

                // Update price display
                updatePriceDisplay(priceBest, priceList);

                // Update selected color
                colorOptions.forEach((el) => el.classList.remove('selected'));
                option.classList.add('selected');

                // Reset size selection
                sizeOptions.forEach((el) => el.classList.remove('selected'));
                selectedSize = null;
                currentId = null;

                // Update size options
                filterSizeOptionsByColor(selectedColor);

                // Hide variation message
                if (variationMessage) {
                    variationMessage.forEach((element) => {
                        element.style.display = 'none';
                    });
                }
            });
        });

        sizeOptions.forEach((option) => {
            option.addEventListener('click', () => {
                sizeOptions.forEach((el) => el.classList.remove('selected'));
                option.classList.add('selected');
                selectedSize = option.dataset.size;
                currentId = option.dataset.id;
                const priceBest = option.dataset.bestprice;
                const priceList = option.dataset.listprice;

                // Hide variation message
                if (variationMessage) {
                    variationMessage.forEach((element) => {
                        element.style.display = 'none';
                    });
                }

                // Update price display
                updatePriceDisplay(priceBest, priceList);
            });
        });
    }

    function updatePriceDisplay(priceBest, priceList) {
        if (!productPriceBest || !productPriceList || !productInstallments) return;

        let numInstallments = 1;
        let minInstallmentValue = 50.00;

        // O parcelamento máximo é de 6x, o valor mínimo de cada parcela é de R$50,00. Fazemos uma validação reversa.
        for (let i = 6; i >= 1; i--) {
            const installmentValue = priceBest / i;
            if (installmentValue >= minInstallmentValue) {
                numInstallments = i;
                break;
            }
        }

        let installments = numInstallments;
        const installmentValue = Math.trunc((priceBest / installments) * 100) / 100;
        const formattedInstallment = installmentValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });

        // alguns produtos tem o priceList idêntico ao priceBest por questão de cadastro.
        if (+priceList <= +priceBest) {
            productPriceList.style.display = 'none';
        } else {
            productPriceList.style.display = 'block';
            productPriceList.innerHTML = Number(priceList).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
            });
        }

        productPriceBest.innerHTML = Number(priceBest).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });

        const pixPrice = ((priceBest - (priceBest * 0.05))).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });

        let installmentsMessage = `<b>${pixPrice} no PIX</b> ou ${installments}x de ${formattedInstallment} s/ juros`;

        if (installments <= 1) installmentsMessage = `<b>${pixPrice} no PIX</b>`;

        productInstallments.innerHTML = installmentsMessage;
    }

    function filterSizeOptionsByColor(selectedColor) {
        const sizeOptions = productCard.querySelectorAll('.size-option');
        let visibleCount = 0;

        sizeOptions.forEach((size) => {
            const sizeColor = size.dataset.color;
            if (sizeColor && sizeColor.toLowerCase() === selectedColor.toLowerCase()) {
                size.style.display = 'inline-block';
                visibleCount++;
            } else {
                size.style.display = 'none';
            }
        });

    }

    // Check if this is a bundle product
    const isBundle = productCard.getAttribute('data-is-bundle') === 'true';

    if (isBundle) {
        // Bundle: add to cart without size/color validation
        addCart.addEventListener('click', () => {
            // Get the variant ID from the bundle container
            const variantId = productCard.getAttribute('data-id');
            
            if (!variantId) {
                console.error('Nenhuma variante disponível para este bundle');
                return;
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1,
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                    openMiniCart();
                })
                .catch((error) => {
                    console.error('Erro ao adicionar ao carrinho:', error);
                });
        });
        return;
    }

    updateSelectors();

    addCart.addEventListener('click', () => {

        if (!currentId) {
            variationMessage.forEach((element) => {
                element.style.display = 'flex';
            });
            return;
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                id: currentId,
                quantity: 1,
                properties: {
                    Cor: selectedColor,
                    Tamanho: selectedSize,
                },
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                openMiniCart();
            })
            .catch((error) => {
                console.error('Erro ao adicionar ao carrinho:', error);
            });
    });

    //quickView
    if (quickView) {
        quickView.addEventListener('click', () => {
            if (!quickViewSizes) {
                console.error('quickViewSizes element not found');
                return;
            }

            quickViewSizes.innerHTML = '';
            const listSizes = productCard.querySelectorAll('.size-option');
            // console.log('selectedColor: ', selectedColor);
            // console.log('Total size options found:', listSizes.length);

            if (listSizes && listSizes.length > 0) {
                let hasSizes = false;
                const addedSizes = new Set(); // Para evitar duplicatas

                listSizes.forEach((size) => {
                    let variantId = size.getAttribute('data-id');
                    let color = size.getAttribute('data-color');
                    let sizeValue = size.textContent.trim();
                    let isDisabled = size.hasAttribute('disabled');

                    if (selectedColor.toLowerCase() == color.toLowerCase() && !addedSizes.has(sizeValue)) {
                        addedSizes.add(sizeValue);
                        hasSizes = true;
                        let button = document.createElement('button');
                        button.type = 'button';
                        button.setAttribute('data-variant-id', variantId);
                        button.setAttribute('data-color', color);
                        button.setAttribute('data-size', sizeValue);
                        button.textContent = sizeValue;

                        if (isDisabled) {
                            button.disabled = true;
                            button.style.opacity = '0.5';
                            button.style.pointerEvents = 'none';
                        }

                        button.addEventListener('click', function () {
                            quickViewSizes.querySelectorAll('button').forEach((btn) => btn.classList.remove('active'));
                            this.classList.add('active');
                        });

                        quickViewSizes.appendChild(button);
                    }
                });

                if (!hasSizes) {
                    quickViewSizes.innerHTML = '<p>Não há tamanhos disponíveis para esta cor</p>';
                }
            } else {
                quickViewSizes.innerHTML = '<p>Não há tamanhos disponíveis</p>';
            }

            document.querySelector('.selectorMob').classList.add('open');
        });
    }
}


(function () {
    var GRID_SELECTOR = '#ProductGridContainer, #product-grid';
    var CARD_SELECTOR = '.product-card';

    function initProductCard(card) {
        if (!card || card.dataset.cardInitialized === 'true') return;
        if (!card.hasAttribute('data-grupo')) return;

        card.dataset.cardInitialized = 'true';

        try {
            scriptsCard(
                card,
                card.getAttribute('data-colorinitial'),
                card.getAttribute('data-grupo')
            );
        } catch (e) {
            delete card.dataset.cardInitialized;
            console.error('Erro ao inicializar card de produto:', e);
        }
    }

    function initProductCards(root) {
        var scope = root || document;

        if (scope.nodeType === 1 && scope.matches && scope.matches(CARD_SELECTOR)) {
            initProductCard(scope);
            return;
        }

        if (!scope.querySelectorAll) return;
        scope.querySelectorAll(CARD_SELECTOR).forEach(initProductCard);
    }

    window.initProductCards = initProductCards;

    var pending = [];
    var scheduled = false;

    function flush() {
        scheduled = false;
        var nodes = pending;
        pending = [];
        nodes.forEach(initProductCards);
    }

    function schedule(node) {
        pending.push(node);
        if (scheduled) return;
        scheduled = true;

        if (window.requestIdleCallback) {
            requestIdleCallback(flush, { timeout: 500 });
        } else {
            setTimeout(flush, 0);
        }
    }

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) schedule(node);
            });
        });
    });

    function start() {
        initProductCards(document);

        document.querySelectorAll(GRID_SELECTOR).forEach(function (grid) {
            if (grid.parentElement && grid.parentElement.closest(GRID_SELECTOR)) return;

            observer.observe(grid, { childList: true, subtree: true });
        });
    }

    if (window.onDomReady) {
        window.onDomReady(start);
    } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
        start();
    }
})();
